import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import {ItemsService} from './items.service';
import {AlertService} from '../../../shared/service/alert.service';

@Component({
  selector: 'app-facility',
  templateUrl: './item.component.html'
})
export class ItemComponent implements OnInit {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private itemsService: ItemsService,
    private alertService: AlertService
  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      facilityId: new FormControl(''),
      pseudoId: new FormControl({value: '', disabled: true}, Validators.required),
      facilityName: new FormControl({value: '', disabled: true}, Validators.required)
    });

    this.route.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.itemsService.get(params.get('id')).subscribe((response) => {
          this.form.patchValue(response);
        });
      }
    });
  }

  delete() {
    this.itemsService.delete(this.form.controls.facilityId.value).subscribe(() => {
      this.alertService.onSuccess().then(() => {
        this.router.navigateByUrl('/Admin/facilities').then();
      });
    });
  }

}
